<template>
  <div id="selGoods" class="common-open-book" @click.stop="close">
    <div class="sel-goods-wrap" @click.stop>
      <div class="common-tit">
        <!-- <span class="tit-head">选择配品</span> -->
        <span class="tit-info"></span>
        <span class="close" @click="close">
          <i class="iconfont icon-guanbi1"></i>
        </span>
      </div>
      <div class="goods">
        <div class="left-cont common-cont">
          <div class="cont-tit active">
            <span>可选配品</span>
          </div>
          <div :class="goodsList.length>9?'cont-list over':'cont-list'">
            <div class="list-head">
              <!-- <span style="width:30%;">分类</span> -->
              <span style="width:50%;">名称</span>
              <!-- <span style="width:10%;">&nbsp;</span> -->
              <span style="width:30%;">分类</span>
              <!-- <span style="width:10%;">库存</span> -->
              <span style="width:20%;">操作</span>
            </div>
            <div class="list-filter">
              <!-- <span class="type-filter filter-normal" style="width:30%;">
                <div class="sel-item" @click.stop>
                  <div
                    class="select"
                    @click.stop="showTypesList?(showTypesList=false):(showTypesList=true,showSelStatus=false)"
                  >
                    <span class="selected-item">{{curSelType?curSelType.name:'全部'}}</span>
                    <i class="iconfont icon-xiala"></i>
                  </div>
                  <div :class="showTypesList?'sel-list show':'sel-list hidden'">
                    <div :class="types.length>1?'list-inner over':'list-inner'">
                      <ul>
                        <li
                          @click="curSelType=null;showTypesList=false"
                          :key="1"
                        >全部</li>
                        <li
                          @click="curSelType=item;showTypesList=false"
                          v-for="(item,index) in types"
                          :key="index+2"
                        >{{item.name}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </span> -->
              <span class="name-filter filter-normal" style="width:50%;">
                  <input type="text" v-model="searchVal" />
              </span>
              <span class="filter-normal" style="width:30%;">-</span>
              <!-- <span class="filter-normal" style="width:10%;">-</span> -->
              <span class="filter-normal search" style="width:20%;">
                  <i class="iconfont icon-sousuo" @click="searchGoods()"></i>
              </span>
            </div>
            <div :class="goodsList.length>9?'goods-list over':'goods-list'">
                <table style="width:100%;">
                    <tr v-for="(item,index) in goodsList" :key="index">
                        <!-- <td style="width:30%"><span style="width:100%;text-overflow:ellipsis;">{{item.typeName}}</span></td> -->
                        <td style="width:50%;text-align:center;">{{item.name}}</td>
                        <!-- <td style="width:10%" class="goods-status"><span class="on">上架</span></td> -->
                        <td style="width:30%">{{item.typeName}}</td>
                        <td style="width:20%" class="add"><span @click="modifyItem('add',item)">添加</span></td>
                    </tr>
                </table>
            </div>
            <!-- <div class="pagination">
                <div class="page-wrap">
                    <span class="total-eles">共{{totalPage}}页 {{totalElements}}条记录</span>
                    <span class="now-page">
                        <i class="iconfont icon-xiala arrow-left" @click="changePage('prev')"></i>
                        <b>{{nowPage+1}}</b>
                        <i class="iconfont icon-xiala" @click="changePage('next')"></i>
                    </span>
                </div>
            </div> -->
          </div>
          <!-- <div class="pagination">
                <div class="page-wrap">
                    <span class="total-eles">共{{totalPage}}页 {{totalElements}}条记录</span>
                    <span class="now-page">
                        <i class="iconfont icon-xiala arrow-left" @click="changePage('prev')"></i>
                        <b>{{nowPage+1}}</b>
                        <i class="iconfont icon-xiala" @click="changePage('next')"></i>
                    </span>
                </div>
            </div> -->
        </div>
        <div :class="nowSelectGoods.length>9?'right-cont common-cont over':'right-cont common-cont'">
          <div class="cont-tit">
            <span>已选配品</span>
          </div>
          <div class="cont-list">
            <div class="list-head">
              <span style="width:50%;">名称</span>
              <span style="width:25%;">数量</span>
              <span style="width:25%;">操作</span>
            </div>
            <div :class="nowSelectGoods.length>10?'goods-list over':'goods-list'">
                <table style="width:100%;">
                    <tr v-for="(item,index) in nowSelectGoods" :key="index">
                        <td style="width:50%">{{item.name}}</td>
                        <td style="width:25%">{{item.count}}</td>
                        <td style="width:25%" class="ruduce" @click="modifyItem('reduce',item)"><span>删减</span></td>
                    </tr>
                </table>
            </div>
          </div>
        </div>
      </div>
      <div class="confirm-set">
        <button @click="close" style="background:#ccc;">关闭</button>
        <button @click="selOk">完成</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props:['storeId','nowSelClass','nowSelClassGoods',"isDiscount","seledGoods"],
    
    data(){
        return{
          searchVal:"",
          size:8,
          types:[],//分类列表
          showTypesList:false,//是否显示分类列表
          curSelType:null,
          goodsList:[],
          totalPage:0,
          totalElements:0,
          nowPage:0,
          canChangePage:true,
          nowSelectGoods:[],
          isSearch:false,
          matData:[],
          unitOptions:[],
          unitFormat:{}
        }
    },
    watch: {
      curSelType(val){
        console.log(val);
        this.nowPage = 0;
        this.getGoods(0);
        this.isSearch = false;
      },
      searchVal(val){
        this.searchGoods();
      }
    },
    methods:{
      // 配品检索
        searchGoods(page=0){
            // let typeId = this.curSelType?this.curSelType.id:"";
            this.nowPage = page;
            this.isSearch = true;
            this.$http({
              url:"products/stores-search",
              params:{
                storeId:this.storeId,
                q:this.searchVal,
                matchProductEnabled:true,
                stockEnabled:false,
                // typeId:"",
                // page:this.nowPage,
                // size:1000
              }
            }).then((res)=>{
                let goodsList = res.data;
                for(let i=0;i<goodsList.length;i++){
                    goodsList[i].count = 0;
                    goodsList[i].productMaterialId = goodsList[i].id;
                    if(goodsList[i].setMealEnabled){
                      goodsList[i].productId = goodsList[i].setMealId
                    }
                }

                this.goodsList = goodsList;
                this.totalPage = res.data.totalPage;
                this.totalElements = res.data.totalElements;
                this.canChangePage = true;
            })
        },
        modifyItem(type,item){
          console.log(item)
          if(item.lowerShelf){
            this.$message({
                message: "此配品已下架!",
                showClose: true,
                customClass: 'error'
            });
            return;
          }
          if(!this.isDiscount){
            if(item.setMealEnabled){
              this.$message({
                  message: "此配品为套餐，不可加入其它套餐!",
                  showClose: true,
                  customClass: 'error'
              });
              return;
            }
          }
          let nowSelectGoods = this.nowSelectGoods;
          if(type == 'add'){
            
            let flag = false;
            let index;
            for(let i=0;i<nowSelectGoods.length;i++){
              if(nowSelectGoods[i].id == item.id){
                flag = true;
                index = i;
              }
            }
            if(flag){
              if(nowSelectGoods[index].count >= 1){
                return;
              }
              nowSelectGoods[index].count++;
            }else{
                item.count++;
                nowSelectGoods.push(item);
            }
            this.nowSelectGoods = nowSelectGoods;
          }else{
            // console.log(nowSelectGoods)
            // console.log(item);
            // return
            let flag = false;
            let index;
            console.log(item.productMaterialId);
            for(let i=0;i<nowSelectGoods.length;i++){
              if(nowSelectGoods[i].id == item.id){
                flag = true;
                index = i;
              }
            }
            console.log(index);
            
            if(this.isDiscount){
              nowSelectGoods.splice(index,1);
            }else{
              if(flag){
                  nowSelectGoods[index].count--;
                  if(nowSelectGoods[index].count <= 0){
                    nowSelectGoods.splice(index,1);
                  }
              }
            }
            this.nowSelectGoods = nowSelectGoods;
          }
          
        },
        changePage(type){
          if(!this.canChangePage){
            console.log("k")
            return;
          }
          let page;
          if(type=='next'){
            page = this.nowPage + 1;
            if(page >= this.totalPage){
              return;
            }
          }else{
            page = this.nowPage - 1;
            if(page < 0){
              return;
            }
          }
          this.canChangePage = false;
          if(this.isSearch){
            this.searchGoods(page);
          }else{
            this.getGoods(page);
          }
          this.nowPage  = page;
        },
        close(){
            this.$emit("closeSelGoods","");
        },
        selOk(){
          let proIds = [];
          for(let i=0;i<this.nowSelectGoods.length;i++){
            if(this.isDiscount){
              if(!this.nowSelectGoods[i].setMealEnabled){
                let obj = {
                  productId:this.nowSelectGoods[i].id,
                  setMealQty:this.nowSelectGoods[i].count,
                  // productName:this.nowSelectGoods[i].productName,
                }
                proIds.push(obj);
              }
            }else{
              let obj = {
                productId:this.nowSelectGoods[i].id,
                setMealQty:this.nowSelectGoods[i].count,
                // productName:this.nowSelectGoods[i].productName,
              }
              proIds.push(obj);
            }
            
          }
          console.log(proIds);
          // this.$http({
          //   url:"/meal/add-pro",
          //   method:"POST",
          //   data:{
          //     id:this.nowSelClass.id,
          //     proIds
          //   }
          // }).then(res=>{
          //   if(res.data.code == 200){
          //   }
          // });
          this.$emit("selOk",{"nowSelectGoods":this.nowSelectGoods,"proIds":proIds});
        },
        // 获取配品
        getGoods(page){
          console.log(this.curSelType)
          let typeId = this.curSelType?this.curSelType.id:""
          this.$http({
            url:'material/search/list',
            method:'GET',
            params:{
              storeId:this.storeId,
              page,
              size:this.size,
            }
          }).then(res=>{
            // this.goodsList = res.data.data;
            // let goodsList = res.data.data;
            // for(let i=0;i<goodsList.length;i++){
            //     goodsList[i].count = 0;
            // }

            let goodsList = res.data;
            for(let i=0;i<goodsList.length;i++){
                goodsList[i].count = 0;
                if(goodsList[i].setMealEnabled){
                  goodsList[i].productId = goodsList[i].setMealId
                }
            }

            this.goodsList = goodsList;
            this.totalPage = res.data.totalPage;
            this.totalElements = res.data.totalElements;
            this.canChangePage = true;
          })
        },
        // 获取配品分类
        getType(){
          this.$http({
            url:"get-type",
            method:"GET",
            params:{
              storeId:this.storeId
            }
          }).then(res=>{
              this.types = res.data;
          })
        },
        getUnitList(){
          this.$http({
              url:"material/unit/list",
              method:"GET",
              params:{
                  storeId:this.storeId,
                  page:0,
                  size:10000
              }
          }).then(res=>{
              this.unitOptions = res.data;
              let unitFormat = {};
              if(res.data && Array.isArray(res.data) && res.data.length){
                  res.data.forEach(it=>{
                      unitFormat[it.id] = it.name
                  })
              }
              console.log(unitFormat)
              this.unitFormat = unitFormat;
              this.getDataList();
          })
        },
        getDataList(){
            this.$http({
                url:"get-ps",
                method:"GET",
                params:{
                    storeId:this.storeId,
                    matchProductEnabled:true,
                }
            }).then(res=>{
                let goodsList = res.data;
                for(let i=0;i<goodsList.length;i++){
                    goodsList[i].count = 0;
                    goodsList[i].productMaterialId = goodsList[i].id;
                    if(goodsList[i].setMealEnabled){
                      goodsList[i].productId = goodsList[i].setMealId
                    }
                }

                this.goodsList = goodsList;
                this.totalPage = res.data.totalPage;
                this.totalElements = res.data.totalElements;
                this.canChangePage = true;
            })
        },
    },
    mounted() {
        this.getDataList();
      // this.getUnitList();
      // this.getType();
      if(this.seledGoods.length){
        let nowSelClassGoods = JSON.parse(JSON.stringify(this.seledGoods));
        // for(let i=0;i<this.nowSelClassGoods.length;i++){
        //   if(this.nowSelClassGoods[i].id){
        //     nowSelClassGoods[i].productName = this.nowSelClassGoods[i].name;
        //     nowSelClassGoods[i].productId = this.nowSelClassGoods[i].id;
        //   }
        // }
        this.nowSelectGoods = nowSelClassGoods;
      }
    },
};
</script>

<style lang="scss">
@import "./selGoods.scss";
@import "./../../../static/css/common.scss";
</style>



// WEBPACK FOOTER //
// selGoods.vue?38fb6be1